const baseButtonSize = {
  small: {
    padding: '8px 16px',
  },
  medium: {
    padding: '12px 24px',
  },
  large: {
    padding: '16px 32px',
  },
};

const buttonSizes = {
  products: {
    chart: baseButtonSize,
    chartblog: baseButtonSize,
    co: baseButtonSize,
    edu: baseButtonSize,
    scale: baseButtonSize,
    spark: baseButtonSize,
  },
};

export type ButtonSizesVariantsType = 'small' | 'medium' | 'large';
export const buttonSizesVariants = Object.keys(baseButtonSize) as ButtonSizesVariantsType[];

export default buttonSizes;
